import styled from 'styled-components'
import { breakpoints, colors, structure } from '@/styles'
import { toUnit } from '@/utils/styles'
import Box from './Box'
import Center from './Center'
import Grid from './Grid'
import Inline from './Inline'
import Stack from './Stack'

const Layout = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding-left: unset;
  }
`

const Wrapper = styled.section`
  display: flex;
  min-height: 100vh;
`

const Content = styled.div<{ sidebarExpanded: boolean; isFullWidth: boolean }>`
  --expanded: ${toUnit(structure.sidebar.widthExpanded)};
  --closed: ${toUnit(structure.sidebar.width)};
  --width: ${props => (props.sidebarExpanded ? 'var(--expanded)' : 'var(--closed)')};

  width: 100%;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  padding-left: ${props =>
    props.isFullWidth ? `0` : `calc(var(--width) + env(safe-area-inset-left, 0px))`};

  margin-right: env(safe-area-inset-left, 0px);

  background-color: ${colors.grey96};

  @media screen and (max-width: ${breakpoints.desktopSmall}) {
    padding-left: 0;
  }

  @media print {
    padding-left: 0;
  }
`

export { Box, Center, Grid, Inline, Stack, Layout, Wrapper, Content }
